module.exports = __webpack_public_path__ + "static/logo-9852b27c5c8b83f360ccb2c528725f39.png";